
L.drawLocal = {
	draw: {
		toolbar: {
			actions: {
				title: 'Cancel drawing',
				text: 'Avbryt'
			},
			finish: {
				title: 'Finish drawing',
				text: 'Avsluta'
			},
			undo: {
				title: 'Delete last point drawn',
				text: 'Ta bort den senast utritade punkten'
			},
			buttons: {
				polyline: 'Dela fält',
				polygon: 'Rita ut en polygon',
				rectangle: 'Rita en rektangel',
				circle: 'Rita en cirkel',
				marker: 'Sätt ut en markör',
				circlemarker: 'Rita en cirkelmarkör'
			}
		},
		handlers: {
			circle: {
				tooltip: {
					start: 'Klicka och dra med muspekaren för att rita en cirkel.'
				},
				radius: 'Radius'
			},
			marker: {
				tooltip: {
					start: 'Klicka på kartan för att placera ut en markör.'
				}
			},
			polygon: {
				tooltip: {
					start: 'Klicka för att börja rita ut polygonen.',
					cont: 'Klicka för att sätta ut nästa punkt',
					end: 'Klicka på den första punkten för att rita klart polygonen.'
				}
			},
			polyline: {
				error: '<strong>Fel:</strong> Kanterna på två figurer får inte överlappa!',
				tooltip: {
					start: 'Klicka för att börja rita ut linje.',
					cont: 'Klicka för att fortsätta rita ut linje.',
					end: 'Klicka på senaste punkten för att färdigställa delningen, alternativt fortsätt sätta ut punkter.'
				}
			},
			rectangle: {
				tooltip: {
					start: 'Klicka och dra med muspekaren för att rita en rektangel.'
				}
			},
			simpleshape: {
				tooltip: {
					end: 'Släpp muspekaren för att rita klart.'
				}
			},
			circlemarker: {
				tooltip: {
					start: 'Click map to place circle marker.'
				}
			}
		}
	},
	edit: {
		toolbar: {
			actions: {
				save: {
					title: 'Save changes.',
					text: 'Spara'
				},
				cancel: {
					title: 'Cancel editing, discards all changes.',
					text: 'Avbryt'
				},
				clearAll: {
					title: 'clear all layers.',
					text: 'Ta bort alla'
				}
			},
			buttons: {
				edit: 'Redigera.',
				editDisabled: 'Det finns inget att redigera.',
				remove: 'Ta bort figur.',
				removeDisabled: 'Det finns inga figurer att ta bort.'
			}
		},
		handlers: {
			edit: {
				tooltip: {
					text: 'Dra i figuren för att redigera den.',
					subtext: 'Klicka på avbryt för att ångra ändringar.'
				}
			},
			remove: {
				tooltip: {
					text: 'Klicka på en figur för att ta bort den.'
				}
			}
		}
	}
};